import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getDesignRate } from "../../../services/ratediary.service";
import { useSelector } from "react-redux";

export default function DesignDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [ratediaryDesign, setRateDiaryDesign] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const designId = params.get("id");

  const fetchDesignrate = async () => {
    try {
      const res = await getDesignRate(token, designId);

      if (res && res.status >= 200 && res.status < 300) {        
        setRateDiaryDesign(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch product details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main product:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the product. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchDesignrate();
  }, [designId]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Design Details</h4>
                <Link
                  to={`/products/designs?product_id=${ratediaryDesign?.product_id}`}
                >
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Design ID */}
                  <div className="col-sm-6 mb-4">
                    <h5>Design ID</h5>
                    <p>{ratediaryDesign?.design_id || "N/A"}</p>
                  </div>

                  {/* Product */}
                  <div className="col-sm-6 mb-4">
                    <h5>Product</h5>
                    <p>{ratediaryDesign?.product_name || "N/A"}</p>
                  </div>

                  {/* Brand */}
                  <div className="col-sm-6 mb-4">
                    <h5>Brand</h5>
                    <p>{ratediaryDesign?.brand_name || "N/A"}</p>
                  </div>

                  {/* Acronym */}
                  <div className="col-sm-6 mb-4">
                    <h5>Acronym</h5>
                    <p>{ratediaryDesign?.brand_acronym || "N/A"}</p>
                  </div>

                  {/* Colors */}
                  <div className="col-sm-6 mb-4">
                    <h5>Colors</h5>
                    <p>{ratediaryDesign?.colors.join(", ") || "N/A"}</p>
                  </div>

                  {/* rate */}
                  <div className="col-sm-6 mb-4">
                    <h5>Rate</h5>
                    <p>₹{(ratediaryDesign?.design_rate * 1)?.toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}</p>
                  </div>

                  {/* Stock */}
                  <div className="col-sm-6 mb-4">
                    <h5>Stock</h5>
                    <p>{ratediaryDesign?.stock}</p>
                  </div>

                  {/* Sizes */}
                  <div className="col-sm-6 mb-4">
                    <h5>Size</h5>
                    <p>{ratediaryDesign?.size_name || "N/A"}</p>
                  </div>

                  {/* Barcode date */}
                  <div className="col-sm-6 mb-4">
                    <h5>Barcode Date</h5>
                    <p>{ratediaryDesign?.barcode_date || "N/A"}</p>
                  </div>

                  {/* In Stock */}
                  <div className="col-sm-6 mb-4">
                    <h5>In Stock</h5>
                    <p>{ratediaryDesign?.inStock ? "Yes" : "No"}</p>
                  </div>

                  <div className="col-md-12 mb-4">
                    <h5>Notes</h5>
                    {ratediaryDesign?.description &&
                    ratediaryDesign.description.length > 0 ? (
                      ratediaryDesign.description.map((desc, index) => (
                        <div key={index} className="description-entry">
                          <p>
                            <strong>{index + 1}: </strong>
                            {desc.content} -{" "}
                            {new Date(desc.date).toLocaleString()}
                          </p>
                        </div>
                      ))
                    ) : (
                      <p>No description provided</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
